import api from './api';

export default {
  /**
   * Autentica usuário com username e password
   * @param {string} username
   * @param {string} password
   * @returns {Promise<{user: {id, username, name}}>}
   */
  async login(username, password) {
    return api.post('/auth/login', { username, password });
  },

  /**
   * Encerra sessão do usuário
   * @returns {Promise<{message: string}>}
   */
  async logout() {
    return api.post('/auth/logout');
  },

  /**
   * Retorna dados do usuário autenticado
   * @returns {Promise<{user: {id, username, name}}>}
   */
  async getMe() {
    return api.get('/auth/me');
  }
};
